import React from 'react';
import { Box } from '@chakra-ui/react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';
import rehypeSanitize from 'rehype-sanitize';

// Dual-support renderer: safely renders BOTH legacy HTML (content created before the
// Markdown switch) and new Markdown, through a single path.
//   - remark-gfm     : GitHub-flavoured Markdown (tables, lists, ...)
//   - rehype-raw     : parse raw HTML embedded in the content (i.e. the old HTML rows)
//   - rehype-sanitize: strip anything unsafe (<script>, on* handlers, javascript: URLs)
// No data migration needed — old HTML just keeps rendering; new Markdown renders too.
export const MarkdownContent = ({ children, ...props }) => (
    <Box className="markdown-body" {...props}>
        <ReactMarkdown
            remarkPlugins={[remarkGfm]}
            rehypePlugins={[rehypeRaw, rehypeSanitize]}
            components={{
                a: ({ node, ...p }) => <a {...p} target="_blank" rel="noopener noreferrer" />,
            }}
        >
            {children || ''}
        </ReactMarkdown>
    </Box>
);

// Plain-text rendition for short table/card previews. Handles both HTML and Markdown
// so legacy and new rows both preview cleanly.
export const markdownToPlain = (value = '') =>
    String(value)
        .replace(/<[^>]+>/g, ' ')                    // strip HTML tags (legacy rows)
        .replace(/!\[[^\]]*\]\([^)]*\)/g, '')        // markdown images
        .replace(/\[([^\]]*)\]\([^)]*\)/g, '$1')     // markdown links -> label
        .replace(/[#>*_~`-]/g, '')                    // heading/emphasis/list/code marks
        .replace(/&nbsp;/gi, ' ')
        .replace(/\s+/g, ' ')
        .trim();

export default MarkdownContent;
